module.exports = __webpack_public_path__ + "img/3ds.08c0df78.svg";